import React, { useEffect, useState } from "react";
import {HISTORY_ICON,CALENDER_ICON, EYE_ICON } from "assets/constants/Icons";
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getHistoryList } from "lib/axiosUtils";
import moment from 'moment';
import BOMViewModal from "components/BOMViewModal";
import { getBomById } from "lib/axiosUtils";
import { TYPE_FAIL, INTERVAL, MODULE_NAMES } from "assets/constants/Constants";
import ShowToast from "components/ShowToast";

const HistoryPage = () => {

  const [logList, setLogList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  useEffect(() => {
    const fetchLogList = async () => {
        try {
            const data = await getHistoryList({}, {});
            setLogList(data.data.result);
        }
        catch (error) {
            console.log("error while fetching data", error);
        }
    }
        fetchLogList();
    },[]);

    const handleOpen = async (bomId) => {
        const response = await getBomById({}, {}, bomId);
        if (!response?.data?.result) {
            ShowToast('Failed to fetch BOM details', TYPE_FAIL, INTERVAL);
            return;
        }
        setSelectedRowData(response.data.result);
        setIsModalOpen(true);
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setSelectedRowData(null);
    };

    function IsItemBOM(item) {
        return item.doc_id && (item.module_name === MODULE_NAMES.CREATE_BOM || item.module_name === MODULE_NAMES.APPROVE_BOM);
    }

  const mytheme= createTheme({});
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15, marginTop: "-25px" }}>
            <div className="col-md-10 sm_device"><i className={`${HISTORY_ICON}`}></i> History </div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">

          <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
              {
                true ? (
                      <ThemeProvider theme={mytheme}>
                          <MaterialTable
                              columns={[
                                  {
                                      title: "Date", field: "date",
                                      width: '8%',
                                      cellStyle: { textTransform: 'none' }
                                  },
                                  {
                                    title: "User", field: "user",
                                    width: '10%',
                                    cellStyle: { fontWeight: 'bolder', color: '#000000' }
                                  },
                                  {
                                      title: "Module Name", field: "module_name",
                                      width: '14%',
                                      cellStyle: { fontWeight: 'bolder', color: '#000000' }
                                  },
                                  {
                                      title: "BOM", field: "bom",
                                      width: '14%',
                                      cellStyle: { textTransform: 'none' },
                                      sorting: false
                                  },
                                  {
                                      title: "Details", field: "details",
                                      width: '54%',
                                      cellStyle: { textTransform: 'none' },
                                      sorting: false
                                  },                              
                              ].filter(Boolean)}
                              data={
                                logList.map((item) => {
                                    return (
                                        {
                                            date: new Date(item.created_date_time).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false 
                                            }),
                                            user: item.full_name,
                                            module_name: item.module_name,
                                            bom: IsItemBOM(item) ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <i className={`${EYE_ICON}`} style={{fontSize:18, cursor: 'pointer'}} title="View BOM" onClick={() => handleOpen(item.doc_id)}></i>
                                                    {item.fixture_document_number && <span style={{ fontWeight: 500 }}>{item.fixture_document_number}</span>}
                                                </div>
                                            ) : <></>,
                                            details: item.log_text,                                         
                                        }
                                    )
                                })
                            }

                              options={{
                                  actionsColumnIndex: -1,
                                  headerStyle: {
                                      color: '#2d3d42',
                                      fontWeight: 'bolder',
                                      fontSize: 14
                                  },
                                  filtering: true,
                                  sorting: true,
                                  columnsButton: true,
                                  exportButton: true,
                                  tableLayout: 'auto',
                                  exportFileName: "History Page Data",
                                  cellStyle: {
                                      color: '#2d3d42',
                                      fontSize: 12
                                  }
                              }}
                          />
                          { isModalOpen && selectedRowData && (
                                BOMViewModal(handleClose, selectedRowData)
                           )}
                      </ThemeProvider>
                  ) : (
                      <div className="text-center pt-2">
                          <label>Not Found</label>
                      </div>
                  )

              }
          </div>
          </div>
        </div>
      )
    }
  </>);
}

export default HistoryPage;